import { render, staticRenderFns } from "./CertificationBadge.vue?vue&type=template&id=547f349a&scoped=true"
import script from "./CertificationBadge.vue?vue&type=script&lang=js"
export * from "./CertificationBadge.vue?vue&type=script&lang=js"
import style0 from "./CertificationBadge.vue?vue&type=style&index=0&id=547f349a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547f349a",
  null
  
)

export default component.exports